import { SelectionModel } from '@angular/cdk/collections';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { debounceTime, Subject } from 'rxjs';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { ServiceOrdersStatusEnum } from 'src/app/domain/registration/enums/service-orders-status.enum';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { S3_URL_BASE } from 'src/environments/environment';
import { GlobalUtils } from '../../global-utils';
import { KeyboardService } from '../keyboard/keyboard.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ButtonConfig } from 'src/app/domain/registration/models/ButtonConfig';

@Component({
  selector: 'table-responsive',
  styleUrls: ['table-responsive.component.sass'],
  templateUrl: 'table-responsive.component.html',
})
export class TableResponsive
  implements OnInit, AfterViewInit, ITableResponsive, OnChanges {
  @Input() currentTab: string = '';
  @Input() userType: string = '';
  isSelectAllChecked: boolean = false;

  constructor(public keyboardService: KeyboardService) { }

  @Input() showViewButton: boolean = false;
  @Output() view = new EventEmitter<any>();
  @Input() showEditButton: boolean = false;
  @Output() edit = new EventEmitter<any>();
  public selectedItems: any[] = [];
  public item: any = null;
  //'visualizar'
  @Input() isEditableShow: boolean = true;
  @Input() insideTheMenu: string[] = [];
  @Input() isEditableEnabled: boolean = true;

  @Input() isDeletableShow: boolean = true;
  @Input() isDeletableEnabled: boolean = true;

  @Input() isLockActionShow: boolean = true;
  @Input() isLockActionEnabled: boolean = true;

  @Input() hasFilter: boolean = true;
  @Input() buttons: ButtonConfig[] = [];
  @Input() lockProperty: string = '';
  @Input() lockPeopleProperty: string = '';
  @Input() infoProperty: string = '';
  @Input() showLock: boolean = false;
  @Input() showPeopleLock: boolean = false;
  @Input() showInfo: boolean = false;
  @Input() showKey: boolean = false;
  @Input() showDashboardButton: boolean = false;
  @Input() showDocumentPhoto: boolean = false;
  @Input() hasAdd: boolean = true;
  @Input() addIcon: string = 'add';
  @Input() hasRefresh: boolean = false;
  @Input() type: TypeIndexEnum = TypeIndexEnum.CRUD;
  @Input() length: number = 0;
  @Output() changePage: EventEmitter<any> = new EventEmitter<any>();
  @Output() filter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() touchSelectChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() buttonAction = new EventEmitter<{ action: string, element: any }>();
  // Propriedade para controlar se o clique na linha deve ativar seleção
  @Input() enableRowClickSelection: boolean = false;
  @Output() openLink: EventEmitter<string> = new EventEmitter<string>();
  @Input() showDownload: boolean = false;
  @Input() downloadProperty: string = '';
  @Input() qrcode: string = '';
  @Output() download: EventEmitter<any> = new EventEmitter();
  @Output() cancelDownload = new EventEmitter<any>();
  @Input() showDescription: boolean = false;
  @Input() descriptionProperty: string = '';
  @Output() description = new EventEmitter<any>();
  @Input() showCancelOrder: boolean = false;
  @Input() cancelOrderProperty: string = '';
  @Output() cancelorder = new EventEmitter<any>();
  @Input() statusProperty: string = '';
  @Output() status = new EventEmitter<any>();
  @Output() whatsApp = new EventEmitter<any>();
  @Output() email = new EventEmitter<any>();
  @Output() birthday = new EventEmitter<any>();
  keyboardChange: EventEmitter<any> = new EventEmitter<any>();
  selectedDate: Date | null = null;
  dateFilterActive: boolean = false;

  @Input() set initialFilterValue(value: string) {
    if (value) {
      this.filterValue = value;
    }
  }

  filterValue: string = '';
  @Input() showPlayButton: boolean = false;
  @Input() showPdfButton: boolean = false;
  @Input() pdfButtonLabel: string = 'PDF';
  @Input() pdfButtonTooltip: string = 'PDF';
  @Input() pdfButtonIcon: string = 'archive';
  @Input() showAprovedButton: boolean = false;
  @Input() showPendingButton: boolean = false;
  @Input() showRejectedButton: boolean = false;
  @Input() showCanceledButton: boolean = false;
  @Input() showAnalysisButton: boolean = false;
  @Input() showOpenChatButton: boolean = false;
  @Input() showRegisterAswersButton: boolean = false;
  @Input() canShowChatButton: (element: any) => boolean = () => true;
  @Input() showWhatsApp = false;
  @Input() showEmail = false;
  @Input() showBirthday = false;
  @Input() showActivities = false;
  @Input() showTransactions = false;
  @Input() birthdayFilter: (contact: any) => boolean;
  @Output() openChatEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() activities = new EventEmitter<any>();
  @Output() openTransactions = new EventEmitter<any>();

  @Input() showBriefingActions: boolean = false;
  @Output() openBriefingQrCode: EventEmitter<any> = new EventEmitter();
  @Output() openBriefingForm: EventEmitter<any> = new EventEmitter();

  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100, 150];

  @Input() initialPageSize?: number;
  @Input() preselectedIds: string[] = [];
  selection = new SelectionModel<any>(true, []);

  @Input() showContractsButton = false;
  @Output() openContractsModal: EventEmitter<any> = new EventEmitter<any>();

  @Input() showPaymentButton = false;
  @Input() canShowPaymentButton: (element: any) => boolean = () => true;
  @Input() paymentButtonIcon = 'payment';
  @Input() paymentButtonTooltip = 'Realizar Pagamento';
  @Output() openPaymentModal: EventEmitter<any> = new EventEmitter<any>();

  @Input() showCancelButton = false;
  @Output() cancelParcel = new EventEmitter<any>();

  @Output() statusFilter = new EventEmitter<string>();

  @Input() actions = [];
  @Input() filters = [];
  @Input() search = true;

  @Output() add = new EventEmitter<boolean>();
  @Output() remove = new EventEmitter<any>();
  @Output() detail = new EventEmitter<any>();

  @Input() showStatus = false;
  @Output() toggleStatus = new EventEmitter<any>();

  @Output() key: EventEmitter<any> = new EventEmitter();
  @Output() dashboard: EventEmitter<any> = new EventEmitter();
  @Output() play: EventEmitter<any> = new EventEmitter();
  @Output() openPdf: EventEmitter<any> = new EventEmitter();

  @Input() loadingDownloads: { [key: string]: boolean } = {};
  @Input() loadingProgress: { [key: string]: number } = {};
  @Input() data: any[] = [];

  ServiceOrdersStatusEnum = ServiceOrdersStatusEnum;
  private filterSubject = new Subject<string>();

  @Input() showCustomButton: boolean = false;
  @Input() customButtonIcon: string = 'dashboard'; // Ícone padrão
  @Input() customButtonTooltip: string = 'Ação Personalizada';
  @Input() customButtonColor: string = 'primary';
  @Output() customButtonClick = new EventEmitter<any>();

  @Input() showRemoveButton: boolean = false;
  @Input() removeButtonTooltip: string = 'Remover da seção';
  @Output() removeButtonClick = new EventEmitter<any>();
  @Output() refreshButtonClick = new EventEmitter<any>();
  @Input() hideShowButton: boolean = false;

  ngOnInit(): void {
    // Configurar pageSize inicial se fornecido
    if (this.initialPageSize && this.initialPageSize > 0) {
      this.pageSize = this.initialPageSize;
    }

    // Adicionar coluna 'actions' se houver botões de ação
    if (this.hasActionButtons() && !this.displayedColumns.includes('actions')) {
      this.displayedColumns = [...this.displayedColumns, 'actions'];
    }

    this.keyboardChange.subscribe((event) => {
      this.applyFilter(event);
    });

    this.filterSubject.pipe(
      debounceTime(500)
    ).subscribe((value) => {
      const filtroValido = value || '';
      this.filter.emit(filtroValido.toUpperCase());
    });
  }

  public pageEvent(event: PageEvent): PageEvent {
    this.changePage.emit({ page: event.pageIndex, limit: event.pageSize });
    return event;
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput
        .split(',')
        .map((str) => +str);
    }
  }

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort = new MatSort();
  @ViewChild('picker') datePicker: MatDatepicker<Date> | undefined;

  @Input('hideFilter') hideFilter: boolean;
  @Input('showCalendar') showCalendar: boolean;
  @Input('hidePagination') hidePagination: boolean;
  @Input('displayedColumns')
  displayedColumns: string[];
  @Input('displayedColumnsOnDetail')
  displayedColumnsOnDetail: string[];
  @Input('dataSource')
  dataSource: MatTableDataSource<any>;
  @Input('configColumns')
  configColumns: IColumnConfigTableResponsive[];
  @Input() showActive: boolean = false;
  @Input() activeProperty: string = '';

  @Output() openShow: EventEmitter<any> = new EventEmitter();
  @Output() openNew: EventEmitter<any> = new EventEmitter();
  @Output() openEdit: EventEmitter<any> = new EventEmitter();
  @Output() openDelete: EventEmitter<any> = new EventEmitter();
  @Output() lock: EventEmitter<any> = new EventEmitter();
  @Output() unlock: EventEmitter<any> = new EventEmitter();
  @Output() lockPeople: EventEmitter<any> = new EventEmitter();
  @Output() unlockPeople: EventEmitter<any> = new EventEmitter();
  @Output() infoAction: EventEmitter<any> = new EventEmitter();
  @Output() playAction: EventEmitter<any> = new EventEmitter();
  @Output() openPdfAction: EventEmitter<any> = new EventEmitter();
  @Output() active: EventEmitter<any> = new EventEmitter();
  @Output() inactive: EventEmitter<any> = new EventEmitter();
  @Output() RegisterCustomersBriefing: EventEmitter<any> = new EventEmitter();
  @Output() DocumentPhoto: EventEmitter<any> = new EventEmitter();

  ngAfterViewInit() {
    if (!this.dataSource) {
      this.dataSource = new MatTableDataSource<any>([]);
    }
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }
  }

  applyFilter(value: string) {
    if (value !== undefined && value !== null) {
      this.filterSubject.next(value);
    } else {
      this.filterSubject.next('');
    }
  }

  /**
   * Alterna o estado "Selecionar Todos".
   * Não manipula mais todos os itens no SelectionModel diretamente.
   */
  masterToggle(): void {
    this.isSelectAllChecked = !this.isSelectAllChecked;
    if (this.isSelectAllChecked) {
      this.selection.clear();
      this.onSelectionChange.emit({ selectAll: true });
    } else {
      this.selection.clear();
      this.onSelectionChange.emit({ selectAll: false, items: [] });
    }
  }

  toggleAllRows(): void {
    if (this.dataSource && this.dataSource.data) {
      this.masterToggle();
    }
  }

  get typeIndexEnum() {
    return TypeIndexEnum;
  }

  get fieldTypeEnum() {
    return FieldTypeEnum;
  }

  public getUrl(value: string) {
    return `${S3_URL_BASE}${value}`;
  }

  downloadFile(url: string): void {
    window.open(url, '_blank');
  }

  descriptionFile(element: any): void {
    this.description.emit(element);
  }

  onCancelReason(element: any): void {
    this.cancelorder.emit(element);
  }

  playRow(element: any): void {
    this.play.emit(element);
  }

  aprovedButton(element: any): void {
    this.status.emit(element);
  }

  pendingButton(element: any): void {
    this.status.emit(element);
  }

  inAnalisingButton(element: any): void {
    this.status.emit(element);
  }

  openChat(element: any): void {
    this.openChatEvent.emit(element);
  }

  rejectedButton(element: any): void {
    this.status.emit(element);
  }

  canceledButton(element: any): void {
    this.status.emit(element);
  }

  inProgressButton(element: any): void {
    this.status.emit(element);
  }

  concludedButton(element: any): void {
    this.status.emit(element);
  }

  pdfShow(element: any): void {
    this.openPdf.emit(element);
  }

  dashboardAction(element: any): void {
    this.dashboard.emit(element);
  }

  showRow(element: any, row: any) {
    element.idx = row;
    this.openShow.emit(element);
  }

  editRow(element: any, row: any) {
    element.idx = row;
    this.openEdit.emit(element);
  }

  deleteRow(element: any, row: any) {
    element.idx = row;
    this.openDelete.emit(element);
  }

  getValue(config: IColumnConfigTableResponsive, data: any, row?: any) {
    if (config.property === 'code') {
      return data;
    }
    return GlobalUtils.getValueByTypeColumnTableResponsive(config, data, row);
  }

  select(element: any, row: any) {
    element.idx = row;
    this.onSelect.emit(element);
  }

  RegisterCustomers(element: any): void {
    this.RegisterCustomersBriefing.emit(element);
  }

  public onCheckRow($event: MouseEvent, idx?: number) {
    if ($event) $event.stopPropagation();
    this.onSelect.emit($event);
  }
  //RegisterCustomersBriefing

  /**
   * Verifica se todos os itens na página *atual* estão selecionados.
   * IMPORTANTE: Esta função NÃO reflete mais o estado de "todos os itens em todas as páginas".
   * Ela é usada principalmente para o estado visual do checkbox mestre.
   * O estado real de "todos" é controlado por `isSelectAllChecked`.
   */
  isAllSelected(): boolean {
    return this.isSelectAllChecked;
  }

  /** Verifica se o checkbox mestre deve estar no estado indeterminado. */
  isMasterCheckboxIndeterminate(): boolean {
    return !this.isSelectAllChecked && this.selection.hasValue();
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  /**
   * Alterna a seleção de uma linha individual.
   * IMPORTANTE: Qualquer seleção/desseleção individual desativa o modo "Selecionar Todos".
   */
  toggleSelection(row: any): void {
    if (this.isSelectAllChecked) {
      // Quando está em modo "selecionar todos", ao clicar em uma linha individual:
      // 1. Desativa o modo "selecionar todos"
      // 2. Seleciona TODAS as linhas exceto a clicada (se ela estava selecionada)
      // 3. Ou seleciona TODAS as linhas incluindo a clicada (se ela não estava selecionada)
      this.isSelectAllChecked = false;

      // Se a linha clicada estava selecionada (modo "todos"), desmarcar apenas ela
      // Se a linha clicada não estava selecionada, selecionar todas exceto ela
      const wasRowSelected = this.selection.isSelected(row);

      if (wasRowSelected) {
        // Desmarcar apenas a linha clicada, manter as outras selecionadas
        this.selection.clear();
        this.dataSource.data.forEach(dataRow => {
          if (dataRow !== row) {
            this.selection.select(dataRow);
          }
        });
      } else {
        // Selecionar todas as linhas incluindo a clicada
        this.selection.clear();
        this.dataSource.data.forEach(dataRow => {
          this.selection.select(dataRow);
        });
      }
    } else {
      // Modo normal: apenas fazer toggle da linha
      this.selection.toggle(row);
    }

    this.onSelectionChange.emit({ selectAll: false, items: this.selection.selected });
  }

  /**
   * Alterna a seleção de uma linha individual por clique na linha.
   * Emite o evento touchSelectChange para notificar o componente pai.
   * Só funciona se enableRowClickSelection estiver habilitado.
   */
  toggleRowSelection(row: any): void {
    // Verificar se a funcionalidade de clique na linha está habilitada
    if (!this.enableRowClickSelection) {
      return;
    }

    if (this.isSelectAllChecked) {
      // Quando está em modo "selecionar todos", ao clicar em uma linha individual:
      // 1. Desativa o modo "selecionar todos"
      // 2. Seleciona TODAS as linhas exceto a clicada (se ela estava selecionada)
      // 3. Ou seleciona TODAS as linhas incluindo a clicada (se ela não estava selecionada)
      this.isSelectAllChecked = false;

      // Se a linha clicada estava selecionada (modo "todos"), desmarcar apenas ela
      // Se a linha clicada não estava selecionada, selecionar todas exceto ela
      const wasRowSelected = this.selection.isSelected(row);

      if (wasRowSelected) {
        // Desmarcar apenas a linha clicada, manter as outras selecionadas
        this.selection.clear();
        this.dataSource.data.forEach(dataRow => {
          if (dataRow !== row) {
            this.selection.select(dataRow);
          }
        });
      } else {
        // Selecionar todas as linhas incluindo a clicada
        this.selection.clear();
        this.dataSource.data.forEach(dataRow => {
          this.selection.select(dataRow);
        });
      }
    } else {
      // Modo normal: apenas fazer toggle da linha
      this.selection.toggle(row);
    }

    // Emitir evento de seleção por clique
    this.touchSelectChange.emit({
      selectAll: false,
      items: this.selection.selected,
      clickedRow: row
    });

    // Também emitir o evento normal de seleção para compatibilidade
    this.onSelectionChange.emit({ selectAll: false, items: this.selection.selected });
  }

  /**
   * Limpa todas as seleções da tabela
   */
  clearSelection(): void {
    this.selection.clear();
    this.isSelectAllChecked = false;
  }

  onEdit(row: any): void {
    this.edit.emit(row);
  }

  onView(row: any): void {
    this.view.emit(row);
  }

  onWhatsApp(row: any): void {
    this.whatsApp.emit(row);
  }

  onEmail(row: any): void {
    this.email.emit(row);
  }

  onBirthday(row: any): void {
    this.birthday.emit(row);
  }

  onActivities(row: any): void {
    this.activities.emit(row);
  }

  onToggleStatus(row: any): void {
    this.toggleStatus.emit(row);
  }

  onRemoveButtonClick(row: any): void {
    this.removeButtonClick.emit(row);
  }

  onRefreshButtonClick(row: any): void {
    this.refreshButtonClick.emit(row);
  }


  hasSelectConfig() {
    return this.displayedColumns.some((col) => col === 'select');
  }

  hasActionButtons() {
    return this.showRemoveButton ||
      this.showOpenChatButton ||
      this.showAprovedButton ||
      this.showPendingButton ||
      this.showRejectedButton ||
      this.showCanceledButton ||
      this.showAnalysisButton ||
      this.showRegisterAswersButton ||
      this.showBriefingActions ||
      this.showContractsButton ||
      this.showPaymentButton ||
      this.showCancelButton ||
      this.showInfo ||
      this.showLock ||
      this.showPeopleLock ||
      this.showKey ||
      this.showActive;
  }

  activeShowLockClass(element: any) {
    if (this.showLock) return element[this.lockProperty] ? 'active' : 'inactive';

    return 'active';
  }

  activeShowPeopleLockClass(element: any) {
    if (this.showPeopleLock) return element[this.lockPeopleProperty] ? 'active' : 'inactive';

    return 'active';
  }

  openContracts(element: any): void {
    this.openContractsModal.emit(element);
  }

  openPayment(element: any): void {
    this.openPaymentModal.emit(element);
  }

  /**
   * Retorna a classe CSS apropriada para colunas do tipo LABEL_FLAG.
   * @param element O objeto da linha da tabela.
   * @param config A configuração da coluna.
   * @returns A string da classe CSS.
   */
  public getStatusClass(element: any, config: IColumnConfigTableResponsive): string {
    const value = element[config.property];

    if (value === true || value === 'SIM') {
      return 'text-green';
    }
    if (value === false || value === 'NÃO') {
      return 'text-red';
    }
    if (value === 'LOADING') {
      return 'text-loading';
    }
    if (value === 'ERRO') {
      return 'text-error';
    }
    if (typeof value === 'string' && value.startsWith('PARCIAL')) {
      return 'text-partial';
    }

    return '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataSource'] && !changes['dataSource'].firstChange) {
      const data = changes['dataSource'].currentValue;
      if (Array.isArray(data)) {
        this.dataSource = new MatTableDataSource<any>(data);
      } else if (data && Array.isArray(data.data)) {
        this.dataSource = new MatTableDataSource<any>(data.data);
      } else if (data) {
        this.dataSource = new MatTableDataSource<any>([]);
        console.warn('TableResponsive: dataSource deve ser um array');
      }

      if (this.dataSource) {
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (item, property) => {
          // Função auxiliar para converter datas em vários formatos
          const parseDateTime = (value: string): number => {
            if (!value) return Number.POSITIVE_INFINITY;
            const cleanedValue = value.replace(/\s+/g, ' ').trim();
            let match = cleanedValue.match(/^(\d{2})\/(\d{2})\/(\d{4})[ ,]? ?(\d{2})?:?(\d{2})?$/);
            if (match) {
              const [, day, month, year, hour = '00', minute = '00'] = match;
              return new Date(`${year}-${month}-${day}T${hour}:${minute}:00`).getTime();
            }
            // Não é data: retorna um valor fixo para ordenar sempre  depois das datas
            return Number.POSITIVE_INFINITY;
          };
          const parseMoney = (value: string): number => {
            if (!value) return Number.POSITIVE_INFINITY;
            // Remove pontos de milhar e troca vírgula decimal por ponto, ex: "1.234,56" -> "1234.56"
            const cleanedValue = value.replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, '').trim();
            const parsed = parseFloat(cleanedValue);
            // Se não for número válido, retorna POSITIVE_INFINITY para ordenar depois dos valores válidos
            return isNaN(parsed) ? Number.POSITIVE_INFINITY : parsed;
          };

          if ((property === 'createdAt' || property === 'estimation') && item[property]) {
            // console.log( 'RETORNO:',parseDateTime(item[property]))
            return parseDateTime(item[property]);
          }

          if ((property === 'totalDue' || property === 'totalOverdue' || property === 'totalPending') && item[property]) {
            console.log('RETORNO:', parseDateTime(item[property]))
            return parseMoney(item[property]);
          }
          // console.log('RETORNO:',item[property] , '::::', typeof item[property])
          return item[property];
        };
      }

      // Apply preselection after data arrives, only if no manual selection has been made yet
      if (this.preselectedIds?.length > 0 && this.dataSource?.data && this.selection.selected.length === 0) {
        const toPreselect = this.dataSource.data.filter(row =>
          this.preselectedIds.includes(String(row?.id))
        );
        toPreselect.forEach(row => this.selection.select(row));
        if (toPreselect.length > 0) {
          this.onSelectionChange.emit({ selectAll: false, items: this.selection.selected });
        }
      }
    }
  }

  /**
   * Manipula o evento do botão de visualizar detalhes.
   * @param element Elemento selecionado
   */
  public onDetail(element: any): void {
    this.detail.emit(element);
  }

  /**
   * Manipula o evento do botão de download.
   * @param element Elemento selecionado
   */
  public onDownload(element: any): void {
    this.download.emit(element);
  }

  public getContrastColor(backgroundColor: string): string {
    if (!backgroundColor || backgroundColor === '#000000' || backgroundColor.length !== 7) {
      return '#ffffff';
    }

    const hex = backgroundColor.replace('#', '');

    if (!/^[0-9A-F]{6}$/i.test(hex)) {
      return '#ffffff';
    }

    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > 0.5 ? '#000000' : '#ffffff';
  }

  public getBadgeColor(element: any, config: IColumnConfigTableResponsive): string {
    if (!config.colorProperty) {
      return '#000000';
    }
    const color = element[config.colorProperty];

    // Log para debug das cores
    if (config.property === 'isParcelPaid') {
      console.log(`getBadgeColor - Element ${element.id}: property=${config.property}, colorProperty=${config.colorProperty}, color=${color}, isParcelPaid=${element.isParcelPaid}, isPaid=${element.isPaid}, isOverdue=${element.isOverdue}`);
    }

    return color && color.trim() !== '' ? color : '#000000';
  }

  isInsideMenu(action: string): boolean {
    return this.insideTheMenu.includes(action);
  }

  isOutsideMenu(action: string): boolean {
    return !this.isInsideMenu(action);
  }

  hasActionMenu(): boolean {
    return this.insideTheMenu.length > 0
  }

  onDateSelected(event: MatDatepickerInputEvent<Date>): void {
    const date = event.value;
    this.filterValue = '';
    if (date) {
      const formattedDateForApi = date.toISOString();
      this.applyFilter(formattedDateForApi);
      //Limpa o campo de pesquisa ao consultar data 
      this.dateFilterActive = true;
    } else this.clearDateFilter();
  }
  clearDateFilter(): void {
    if (this.datePicker) {
      this.datePicker.select(undefined as any); // Limpa a seleção do datepicker
    }
    this.dateFilterActive = false; // Desativa o botão de limpar
    this.applyFilter(this.filterValue); // Re-aplica o filtro atual (texto) ou vazio se não houver texto
  }

  /**
   * Função chamada pelo clique no botão no template.
   * Ela pega a ação definida na configuração e o elemento da linha,
   * e emite ambos para o componente pai.
   * @param action O identificador da ação (ex: 'details', 'edit')
   * @param element O objeto de dados da linha atual
   */
  onButtonClick(action: string, element: any): void {
    this.buttonAction.emit({ action, element });
  }
}
